var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-base",
    {
      attrs: {
        title: !_vm.resendActive
          ? _vm.$t("REGISTRATION_CODE_STEP.TITLE")
          : _vm.$t("REGISTRATION_CODE_STEP.RESEND.TITLE")
      }
    },
    [
      _c("template", { slot: "content" }, [
        _c(
          "div",
          {
            staticClass: "bk-reg__opener mdc-typography mdc-typography--body2"
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(
                  !_vm.resendActive
                    ? _vm.$t("REGISTRATION_CODE_STEP.ENTER_SECURITY_CODE")
                    : _vm.$t("REGISTRATION_CODE_STEP.RESEND.DESCRIPTION")
                ) +
                "\n  "
            )
          ]
        ),
        _vm._v(" "),
        !_vm.resendActive
          ? _c(
              "div",
              [
                _c("bk-input", {
                  staticClass: "input",
                  attrs: {
                    icon: "lock",
                    label: _vm.$t("REGISTRATION_CODE_STEP.SECURITY_CODE"),
                    value: _vm.registrationCode,
                    valid: _vm.isRegistrationCodeValid,
                    pristine: _vm.registrationCodePristine,
                    id: "registrationCode",
                    "helper-text": _vm.$t(_vm.helperTextState),
                    loading: _vm.registrationCodeLoading
                  },
                  on: { input: _vm.changeRegistrationCode }
                }),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(_vm.$t("REGISTRATION_CODE_STEP.GOT_NO_EMAIL_LABEL"))
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "back-button aligned",
                    on: {
                      click: function($event) {
                        _vm.resendActive = true
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("REGISTRATION_CODE_STEP.GET_NO_EMAIL"))
                    )
                  ]
                )
              ],
              1
            )
          : _c(
              "div",
              [
                _c("bk-email", {
                  attrs: {
                    email: _vm.email,
                    valid: _vm.emailValid && _vm.emailAddressIsValid,
                    state: _vm.emailState,
                    id: "resendEmailInput",
                    loading: _vm.emailLoading
                  },
                  on: { change: _vm.emailChange }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "back-button",
                    on: {
                      click: function($event) {
                        _vm.resendActive = false
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.$t("GLOBAL.BACK")) + "\n    "
                    )
                  ]
                )
              ],
              1
            )
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "buttons" },
        [
          !_vm.resendActive
            ? _c(
                "bk-button",
                {
                  attrs: { disabled: !_vm.registrationCodeLengthIsValid },
                  on: { click: _vm.validateRegistrationCode }
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm.$t("REGISTRATION_CODE_STEP.CONFIRM")) +
                      "\n  "
                  )
                ]
              )
            : _c("bk-button", { on: { click: _vm.resendRegistrationCode } }, [
                _vm._v(_vm._s(_vm.$t("REGISTRATION_CODE_STEP.RESEND.BUTTON")))
              ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }